module.exports = __webpack_public_path__ + "static/media/co2-impact.4525979c.png";